import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'app-date-picker',
	templateUrl: './date-picker.component.html',
	styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent implements OnInit, OnChanges {
	@ViewChild('startDate') startDate: ElementRef;
	@ViewChild('endDate') endDate: ElementRef;
	// tslint:disable-next-line:max-line-length
	@Input() model: { date: Date, placeholder: string, format: string, disabled?: boolean, readonly?: boolean, required?: boolean, message?: string } = { date: new Date(), placeholder: 'Select Date', format: 'dd/MM/yyyy', disabled: false, readonly: false, required: false };
	@Output() dateChanged = new EventEmitter<any>();
	@Input() dateId = 'date';
	oldDate: string;
	showErrorMsg = false;
	dateOuptut: { fromDate: any, toDate: any, status: boolean, changed: string } = {
		fromDate: '', toDate: '', status: true, changed: ''
	}

	/**
	 * Date Range Picker
	 */
	@Input() rangePicker: DateRangeModel = {
		reset: false,
		from: {
			date: new Date()
		},
		to: {
			date: new Date()
		},
		format: 'dd/MM/yyyy'
	};

	constructor(
		private scriptLoaderService: ScriptLoaderService
	) { }

	ngOnChanges(changes: SimpleChanges) {
		console.log('Changes triggered in date picker')
		if (changes.model && changes.model.currentValue) {
			this.rangePicker = undefined;
			// console.log(changes.model);
			this.model.date = new Date(this.model.date);
			const day = ((this.model.date.getDate()) < 10) ? `0${this.model.date.getDate() + 1}` : this.model.date.getDate;
			const month = ((this.model.date.getMonth() + 1) < 10) ? `0${this.model.date.getMonth() + 1}` : this.model.date.getMonth() + 1;
			this.oldDate = `${day}/${month}/${this.model.date.getFullYear()}`;
			// console.log('oldDate', this.oldDate);
			this.dateChanged.emit(this.model.date);
			// this.oldDate = new Date(this.model.date);
		} else if (changes.rangePicker && changes.rangePicker.currentValue) {
			if (this.rangePicker.reset) {
				const today = new Date();
				this.startDate.nativeElement.value = this.endDate.nativeElement.value =
					// tslint:disable-next-line:max-line-length
					`${(today.getDate() < 10) ? `0${today.getDate()}` : today.getDate()}/${((today.getMonth() + 1) < 10) ? `0${(today.getMonth() + 1)}` : (today.getMonth() + 1)}/${today.getFullYear()}`;
			}
			// const fromDate = this.convertDate(this.rangePicker.from.date, this.rangePicker.format);
			// this.rangePicker.from.date = fromDate;
			// const toDate = this.convertDate(this.rangePicker.to.date, this.rangePicker.format);
			// this.rangePicker.to.date = toDate;
		}
	}

	ngOnInit() {
		this.scriptLoaderService.addScriptTagToElementDOM('../assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js');
	}

	convertDate(inputDate) {
		function pad(s) { return (s < 10) ? '0' + s : s; }
		const d = new Date(inputDate);
		// if (dateFormat.search('-') !== -1) {
		// 	return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-');
		// } else {
		// 	return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
		// }
		return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
	}

	onDateChange(event) {
		if ((event.target.value === '') && this.model.required === true) {
			this.showErrorMsg = true;
		} else {
			this.showErrorMsg = false;
		}
		if (this.oldDate !== event.target.value) {
			this.oldDate = event.target.value;
			// console.log(event.target.value);
			const [day, month, year] = (event.target.value).split('/');
			// console.log(day, month, year);
			// console.log(new Date(year, month - 1, day));
			this.dateChanged.emit(new Date(year, month - 1, day, 5, 30, 0));
		}

	}

	onDateRangeChange(event, type: string) {
		if (type === 'start') {
			const [day, month, year] = (event.target.value).split('/');
			const toDate = this.convertDate(this.rangePicker.to.date);
			const [day1, month1, year1] = toDate.split('/');
			if (day === day1) {
				this.dateChanged.emit({
					from: new Date(year, month - 1, day, 5, 30, 0),
					to: new Date(year, month - 1, day, 5, 30, 0)
				});
			} else if (day < day1) {
				this.dateChanged.emit({
					from: new Date(year, month - 1, day),
					to: new Date(Number(year1), Number(month1) - 1, Number(day1), 5, 30, 0)
				});
			} else {
				this.dateChanged.emit({
					from: new Date(year, month - 1, day, 5, 30, 0),
					to: new Date(Number(year1), Number(month1) - 1, Number(day1), 5, 30, 0)
				});
			}
		} else {
			const [day, month, year] = (event.target.value).split('/');
			const toDate = this.convertDate(this.rangePicker.from.date);
			const [day1, month1, year1] = toDate.split('/');
			if (day === day1) {
				this.dateChanged.emit({
					from: new Date(year, month - 1, day, 5, 30, 0),
					to: new Date(year, month - 1, day, 5, 30, 0)
				});
			} else if (day < day1) {
				this.dateChanged.emit({
					from: new Date(Number(year1), Number(month1) - 1, Number(day1)),
					to: new Date(year, month - 1, day, 5, 30, 0)
				});
			} else {
				this.dateChanged.emit({
					from: new Date(Number(year1), Number(month1) - 1, Number(day1), 5, 30, 0),
					to: new Date(year, month - 1, day, 5, 30, 0)
				});
			}
		}
	}

	onDurationChange(event, type) {
		if (String(event.target.value !== 'Invalid Date')) {
			console.log(event.target.value);
			const dateString = (event.target.value).split('/');
			const date = new Date(dateString[2], dateString[1] - 1, dateString[0]);
			if (this.rangePicker.rangeDiff) {
				if (type === 'start') {
					this.dateOuptut = {
						fromDate: date,
						toDate: new Date(),
						status: false,
						changed: type
					}
					this.dateOuptut.toDate.setDate(date.getDate() + this.rangePicker.rangeDiff);
					console.log('date', this.dateOuptut);
					this.dateChanged.emit(this.dateOuptut);
				} else {
					const today = new Date();
					if (date <= today) {
						this.dateOuptut = {
							fromDate: this.dateOuptut.fromDate,
							toDate: date,
							status: true,
							changed: type
						}
						console.log('date', this.dateOuptut);
						this.dateChanged.emit(this.dateOuptut);
					} else if (Math.abs(today.getDate() - date.getDate()) < 3) {
						this.dateOuptut.status = true;
						this.dateOuptut.changed = type;
						console.log('date', this.dateOuptut);
						this.dateChanged.emit(this.dateOuptut);
					} else {
						this.dateOuptut = {
							fromDate: new Date(),
							toDate: date,
							status: false,
							changed: type
						}
						this.dateOuptut.fromDate.setDate(date.getDate() - this.rangePicker.rangeDiff);
						console.log(today.getDate(), this.dateOuptut.toDate.getDate());
						console.log('date', this.dateOuptut);
						this.dateChanged.emit(this.dateOuptut);
					}
				}
			} else {
				if (type === 'start') {
					this.dateOuptut = {
						changed: type,
						fromDate: date,
						status: false,
						toDate: this.dateOuptut.toDate
					}
				} else {
					this.dateOuptut = {
						changed: type,
						fromDate: this.dateOuptut.fromDate,
						status: false,
						toDate: date
					}
				}
				this.dateChanged.emit(this.dateOuptut)
			}
		}
	}

}

export interface DateModel {
	date: any;
	placeholder: string;
	format: string;
	disabled?: boolean;
	readonly?: boolean;
	required?: boolean;
	message?: string;
}

export interface DateRangeModel {
	reset?: boolean;
	from: {
		date: any,
		placeholder?: string
	};
	to: {
		date: any,
		placeholder?: string
	};
	format: string,
	rangeDiff?: number,
	errorMessage?: string
}
